var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * 
 * @file Content sub header component
 * @author Box
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'box-react-ui/lib/components/button/Button';
import DropdownMenu from 'box-react-ui/lib/components/dropdown-menu/DropdownMenu';
import Menu from 'box-react-ui/lib/components/menu/Menu';
import MenuItem from 'box-react-ui/lib/components/menu/MenuItem';
import IconCheck from 'box-react-ui/lib/icons/general/IconCheck';
import IconSort from 'box-react-ui/lib/icons/general/IconSort';
import messages from '../messages';
import { FIELD_NAME, FIELD_DATE, SORT_ASC, SORT_DESC } from '../../constants';

var SORT_ITEMS = [[FIELD_NAME, SORT_ASC], [FIELD_NAME, SORT_DESC], [FIELD_DATE, SORT_ASC], [FIELD_DATE, SORT_DESC]];

var Sort = function Sort(_ref) {
    var isLoaded = _ref.isLoaded,
        sortBy = _ref.sortBy,
        sortDirection = _ref.sortDirection,
        onSortChange = _ref.onSortChange;
    return React.createElement(
        DropdownMenu,
        { isRightAligned: true, constrainToScrollParent: true },
        React.createElement(
            Button,
            { type: 'button', isDisabled: !isLoaded, className: 'be-btn-sort' },
            React.createElement(IconSort, null)
        ),
        React.createElement(
            Menu,
            { className: 'be-menu-sort' },
            SORT_ITEMS.map(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    sortByValue = _ref3[0],
                    sortDirectionValue = _ref3[1];

                var isSelected = sortByValue === sortBy && sortDirectionValue === sortDirection;
                var sortItemKey = '' + sortByValue + sortDirectionValue;

                return React.createElement(
                    MenuItem,
                    {
                        key: sortItemKey,
                        onClick: function onClick() {
                            return onSortChange(sortByValue, sortDirectionValue);
                        }
                    },
                    React.createElement(
                        'div',
                        { className: 'be-sort-selected' },
                        isSelected && React.createElement(IconCheck, { width: 16, height: 16 })
                    ),
                    React.createElement(FormattedMessage, messages[sortItemKey])
                );
            })
        )
    );
};

export default Sort;